const { host } = window.location;
let browserEnv: string;
if (host.startsWith('localhost')) {
  browserEnv = 'local';
} else if (host.split('.')[0].endsWith('-minside-d')) {
  browserEnv = 'dev';
} else if (host.split('.')[0].endsWith('-minside-t') || host.split('.')[1].endsWith('test')) {
  browserEnv = 'test';
} else {
  browserEnv = 'production';
}

interface IEnvironment {
  ApiBaseUrl: string;
  MsalClientId: string;
  MsalScope: string;
  MsalInternalUserAuthority: string;
  MsalExternalUserAuthority: string;
  MsalPasswordResetAuthority: string;
  MsalChangeSigninEmailAuthority: string;
  MsalEditPhoneNumberAuthority: string;
  IdPortenValidateAuthority: string;
  StatsforvalterenDomainHint: string;
  Current: 'local' | 'dev' | 'test' | 'production';
  ApplicationInsightsConnectionString: string;
}

let env: IEnvironment | undefined;

if (browserEnv === 'local' || browserEnv === 'dev')
  env = {
    ApiBaseUrl: browserEnv === 'local' ? 'https://localhost:4001' : 'https://minsideapi-minside-d.miljodirektoratet.no',
    MsalClientId: '87e0c34f-d149-4e0a-a140-86f979d0b13a',
    MsalScope: 'https://miljodirb2cdev.onmicrosoft.com/87e0c34f-d149-4e0a-a140-86f979d0b13a/default',
    MsalInternalUserAuthority:
      'https://miljodirb2cdev.b2clogin.com/miljodirb2cdev.onmicrosoft.com/B2C_1A_signup_signin_internal_user',
    MsalExternalUserAuthority:
      'https://miljodirb2cdev.b2clogin.com/miljodirb2cdev.onmicrosoft.com/B2C_1A_signup_signin_external_user',
    MsalPasswordResetAuthority:
      'https://miljodirb2cdev.b2clogin.com/miljodirb2cdev.onmicrosoft.com/B2C_1A_password_reset',
    MsalChangeSigninEmailAuthority:
      'https://miljodirb2cdev.b2clogin.com/miljodirb2cdev.onmicrosoft.com/B2C_1A_change_signin_email_external_user',
    MsalEditPhoneNumberAuthority:
      'https://miljodirb2cdev.b2clogin.com/miljodirb2cdev.onmicrosoft.com/B2C_1A_profile_edit_phone_number',
    IdPortenValidateAuthority:
      'https://miljodirb2cdev.b2clogin.com/miljodirb2cdev.onmicrosoft.com/B2C_1A_idporten_validation',
    StatsforvalterenDomainHint: 'statsforvalteren.onmicrosoft.com',
    Current: browserEnv,
    ApplicationInsightsConnectionString:
      'InstrumentationKey=872cbee7-4059-4587-b777-8d000221a9dd;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=029e9e47-d916-4b74-9113-245d5714c701'
  };
else if (browserEnv === 'test')
  env = {
    ApiBaseUrl: 'https://minsideapi-minside-t.miljodirektoratet.no',
    MsalClientId: '7c532e17-83d6-48a5-85c0-426ba2b509e8',
    MsalScope: 'https://miljodirb2ctest.onmicrosoft.com/7c532e17-83d6-48a5-85c0-426ba2b509e8/default',
    MsalInternalUserAuthority:
      'https://miljodirb2ctest.b2clogin.com/miljodirb2ctest.onmicrosoft.com/B2C_1A_signup_signin_internal_user',
    MsalExternalUserAuthority:
      'https://miljodirb2ctest.b2clogin.com/miljodirb2ctest.onmicrosoft.com/B2C_1A_signup_signin_external_user',
    MsalPasswordResetAuthority:
      'https://miljodirb2ctest.b2clogin.com/miljodirb2ctest.onmicrosoft.com/B2C_1A_password_reset',
    MsalChangeSigninEmailAuthority:
      'https://miljodirb2ctest.b2clogin.com/miljodirb2ctest.onmicrosoft.com/B2C_1A_change_signin_email_external_user',
    MsalEditPhoneNumberAuthority:
      'https://miljodirb2ctest.b2clogin.com/miljodirb2ctest.onmicrosoft.com/B2C_1A_profile_edit_phone_number',
    IdPortenValidateAuthority:
      'https://miljodirb2ctest.b2clogin.com/miljodirb2ctest.onmicrosoft.com/B2C_1A_idporten_validation',
    StatsforvalterenDomainHint: 'statsforvalteren.onmicrosoft.com',
    Current: browserEnv,
    ApplicationInsightsConnectionString:
      'InstrumentationKey=2da245da-643b-4ff8-94a7-69fa3b5d87b2;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=c6d692dd-c12c-4461-b74e-74ee55327feb'
  };
else if (browserEnv === 'production')
  env = {
    ApiBaseUrl: 'https://minsideapi-minside-p.miljodirektoratet.no',
    MsalClientId: 'e861fc3f-95ab-4895-b43c-ff05a1d0f023',
    MsalScope: 'https://miljodirb2cprod.onmicrosoft.com/96984284-0be0-47c4-9dee-3af1ed9aa6ce/minside.api.default',
    MsalInternalUserAuthority:
      'https://miljodirb2cprod.b2clogin.com/miljodirb2cprod.onmicrosoft.com/B2C_1A_signup_signin_internal_user',
    MsalExternalUserAuthority:
      'https://miljodirb2cprod.b2clogin.com/miljodirb2cprod.onmicrosoft.com/B2C_1A_signup_signin_external_user',
    MsalPasswordResetAuthority:
      'https://miljodirb2cprod.b2clogin.com/miljodirb2cprod.onmicrosoft.com/B2C_1A_password_reset',
    MsalChangeSigninEmailAuthority:
      'https://miljodirb2cprod.b2clogin.com/miljodirb2cprod.onmicrosoft.com/B2C_1A_change_signin_email_external_user',
    MsalEditPhoneNumberAuthority:
      'https://miljodirb2cprod.b2clogin.com/miljodirb2cprod.onmicrosoft.com/B2C_1A_profile_edit_phone_number',
    IdPortenValidateAuthority:
      'https://miljodirb2cprod.b2clogin.com/miljodirb2cprod.onmicrosoft.com/B2C_1A_idporten_validation',
    StatsforvalterenDomainHint: 'statsforvalteren.onmicrosoft.com',
    Current: browserEnv,
    ApplicationInsightsConnectionString:
      'InstrumentationKey=c4b8d471-eba8-46fc-861c-f9043ef50bc0;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=f33e8060-c60b-4b8d-9c5d-f202131bdcd9'
  };

if (env === undefined) throw new Error('Environment variables not set.');

const Environment = env;

export default Environment;
